/**
 * @overview 主应用路由
 */
/**
 * 系统中心
 */
import Role from  '@/views/Role'; // 角色权限
import Router from '@/views/Router'; // 路由结构
import Campus from '@/views/CampusManagement'; // 校区管理
import Courseware from '@/views/Courseware'; // 课件
import Goods from '@/views/Goods'; // 课程商品
import CourseGoods from '@/views/CourseGoods'; // 课程商品
import ClientLog from '@/views/ClientLog/router'; // 客户端日志

const routes = [
  ...Role,
  ...Router,
  ...Campus,
  ...Courseware,
  ...Goods,
  ...CourseGoods,
  ...ClientLog,
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/main.js